module.exports = __webpack_public_path__ + "img/21_103.18be0416.png";